/** Filtering applies to typed captured URL fields, never transport destinations or arbitrary text. */
export type UrlPolicy = 'full' | 'origin-only';

export function normalizeUrlPolicy(value: unknown): UrlPolicy {
  if (value === undefined || value === 'full') return 'full';
  if (value === 'origin-only') return 'origin-only';
  throw new Error('[Perspectify] urlPolicy must be full or origin-only');
}

export function capturedUrl(value: string, policy: UrlPolicy, base?: string): string;
export function capturedUrl(value: undefined, policy: UrlPolicy, base?: string): undefined;
export function capturedUrl(value: string | undefined, policy: UrlPolicy, base?: string): string | undefined;
export function capturedUrl(value: string | undefined, policy: UrlPolicy, base?: string): string | undefined {
  if (value === undefined || policy === 'full') return value;
  if (typeof value !== 'string' || value === '') return '';
  try {
    const parsed = new URL(value, base);
    return parsed.protocol === 'http:' || parsed.protocol === 'https:' ? parsed.origin : '';
  } catch {
    return '';
  }
}

export function capturedUrlHeaders(headers: Record<string, string>, policy: UrlPolicy, base?: string): Record<string, string>;
export function capturedUrlHeaders(headers: undefined, policy: UrlPolicy, base?: string): undefined;
export function capturedUrlHeaders(headers: Record<string, string> | undefined, policy: UrlPolicy, base?: string): Record<string, string> | undefined;
export function capturedUrlHeaders(headers: Record<string, string> | undefined, policy: UrlPolicy, base?: string): Record<string, string> | undefined {
  if (!headers || policy === 'full') return headers;
  return Object.fromEntries(Object.entries(headers).map(([name, value]) => [
    name,
    /^(referer|location|content-location)$/i.test(name) ? capturedUrl(value, policy, base) : value,
  ]));
}
